(() => {
  document.querySelectorAll("a").forEach((link) => {
    link.hostname !== location.hostname &&
      link.setAttribute("target", "_blank");
  });
})();
